export default __webpack_public_path__ + "static/media/tag.fcdbeae2.svg";